var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 31.25A6.257 6.257 0 0025 25H12.5a6.257 6.257 0 006.25 6.25zM26.563 20.313a1.563 1.563 0 100-3.126 1.563 1.563 0 000 3.125zM10.938 20.313a1.563 1.563 0 100-3.126 1.563 1.563 0 000 3.125zM0 17.969v9.375c0 .43.35.781.781.781h2.344V17.187H.781c-.43 0-.781.351-.781.782zM12.5 7.813H25v1.562H12.5V7.812zM36.719 17.188h-2.344v10.937h2.344c.43 0 .781-.35.781-.781v-9.375c0-.43-.35-.782-.781-.782z",
    fill: "#3A50F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.469 10.938H7.03a2.347 2.347 0 00-2.343 2.343v18.75a2.347 2.347 0 002.343 2.344H30.47a2.347 2.347 0 002.343-2.344v-18.75a2.347 2.347 0 00-2.343-2.344zM7.812 18.75a3.128 3.128 0 013.125-3.125 3.128 3.128 0 013.126 3.125 3.128 3.128 0 01-3.126 3.125 3.128 3.128 0 01-3.124-3.125zM26.563 25c0 4.308-3.504 7.813-7.812 7.813S10.937 29.308 10.937 25v-.781c0-.431.35-.782.782-.782H25.78c.431 0 .782.35.782.782V25zm0-3.125a3.128 3.128 0 01-3.125-3.125 3.128 3.128 0 013.125-3.125 3.128 3.128 0 013.125 3.125 3.128 3.128 0 01-3.125 3.125zM18.75 3.125a1.563 1.563 0 100-3.125 1.563 1.563 0 000 3.125zM18.75 4.687c-.271 0-.53-.045-.781-.11V7.03h1.562V4.577c-.251.065-.51.11-.781.11z",
    fill: "#3A50F3"
  })));
}

export default __webpack_public_path__ + "./fonts/bot.23877c3ed65b9cd5fe698f7fb8dba08e.svg";
export { SvgBot as ReactComponent };